
	/* base64EncodeDecode  */

        export function base64EncodeDecode(string, direction) {

            // https://scotch.io/quick-tips/how-to-encode-and-decode-strings-with-base64-in-javascript
            
            // Create Base64 Object
                // var Base64={_keyStr:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",encode:function(e){var t="";var n,r,i,s,o,u,a;var f=0;e=Base64._utf8_encode(e);while(f<e.length){n=e.charCodeAt(f++);r=e.charCodeAt(f++);i=e.charCodeAt(f++);s=n>>2;o=(n&3)<<4|r>>4;u=(r&15)<<2|i>>6;a=i&63;if(isNaN(r)){u=a=64}else if(isNaN(i)){a=64}t=t+this._keyStr.charAt(s)+this._keyStr.charAt(o)+this._keyStr.charAt(u)+this._keyStr.charAt(a)}return t},decode:function(e){var t="";var n,r,i;var s,o,u,a;var f=0;e=e.replace(/[^A-Za-z0-9\+\/\=]/g,"");while(f<e.length){s=this._keyStr.indexOf(e.charAt(f++));o=this._keyStr.indexOf(e.charAt(f++));u=this._keyStr.indexOf(e.charAt(f++));a=this._keyStr.indexOf(e.charAt(f++));n=s<<2|o>>4;r=(o&15)<<4|u>>2;i=(u&3)<<6|a;t=t+String.fromCharCode(n);if(u!=64){t=t+String.fromCharCode(r)}if(a!=64){t=t+String.fromCharCode(i)}}t=Base64._utf8_decode(t);return t},_utf8_encode:function(e){e=e.replace(/\r\n/g,"\n");var t="";for(var n=0;n<e.length;n++){var r=e.charCodeAt(n);if(r<128){t+=String.fromCharCode(r)}else if(r>127&&r<2048){t+=String.fromCharCode(r>>6|192);t+=String.fromCharCode(r&63|128)}else{t+=String.fromCharCode(r>>12|224);t+=String.fromCharCode(r>>6&63|128);t+=String.fromCharCode(r&63|128)}}return t},_utf8_decode:function(e){var t="";var n=0;var r=c1=c2=0;while(n<e.length){r=e.charCodeAt(n);if(r<128){t+=String.fromCharCode(r);n++}else if(r>191&&r<224){c2=e.charCodeAt(n+1);t+=String.fromCharCode((r&31)<<6|c2&63);n+=2}else{c2=e.charCodeAt(n+1);c3=e.charCodeAt(n+2);t+=String.fromCharCode((r&15)<<12|(c2&63)<<6|c3&63);n+=3}}return t}}

            // Encode the String
                if(direction === "encode") {
                    return btoa(string);
                    //return Base64.encode(string);
                }

            // Decode the String
                if(direction === "decode") {
                    return atob(string);
                    //return Base64.decode(string);
                }

        }

	/* base64EncodeDecode  */

	

	/* decryptMailtoAndPhone */

		// 1 - data('inner') NOT SET
			// rein: <a class="mailto" data-user="user" data-domain="domain" data-tld="tld" href="#">Irgendwas</a>
			// raus: <a class="mailto" data-user="user" data-domain="domain" data-tld="tld" href="mailto:user@domain.tld">Irgendwas</a>

		// 2 - data('inner') SET = thisEmail
			// rein: <a class="mailto" data-user="user" data-domain="domain" data-tld="tld" data-inner="thisEmail" href="#">Irgendwas</a>
			// raus: <a class="mailto" data-user="user" data-domain="domain" data-tld="tld" data-inner="thisEmail" href="mailto:user@domain.tld">user@domain.tld</a>

		// 3 - data('inner') SET = "Custom Text"
			// rein: <a class="mailto" data-user="user" data-domain="domain" data-tld="tld" data-inner="Say Hello" href="#">Irgendwas</a>
			// raus: <a class="mailto" data-user="user" data-domain="domain" data-tld="tld" data-inner="Say Hello" href="mailto:user@domain.tld">Say Hello</a>


        export function decryptMailtoAndPhone() {

            // mailto
                const $matchesMailto = document.querySelectorAll('a.mailto');
                $matchesMailto.forEach(($link) => {
                    // compose email-address
                        var emailAddress = $link.dataset.user + '@' + $link.dataset.domain + '.' + $link.dataset.tld ;
                    // set href
                        $link.setAttribute('href', 'mailto:' + emailAddress);
                    // set innerHTML
                        if($link.dataset.inner !== undefined) {
                            if($link.dataset.inner === "thisEmail") {
                                $link.innerHTML = emailAddress;
                            } else {
                                $link.innerHTML = $link.dataset.inner;
                            }
                        }
                });

            // tel
                const $matchesTel = document.querySelectorAll('a.tel');
                $matchesTel.forEach(($link) => {
                    // compose tel
                        var tel = base64EncodeDecode($link.dataset.crypttel, 'decode') ;
                    // set href
                        $link.setAttribute('href', 'tel:' + tel);
                    // set innerHTML
                        if($link.dataset.cryptinner !== undefined) {
                            $link.innerHTML = base64EncodeDecode($link.dataset.cryptinner, 'decode');
                        }
                });

        }

        decryptMailtoAndPhone();

	/* decryptMailtoAndPhone */